import { Inject, Component, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialog } from "@angular/material/dialog";
import { Methods } from "../../../shared/methods";

declare const $: any;

import { Router, ActivatedRoute, Params } from "@angular/router";
//import { Observable } from 'rxjs-compat';
import { Observable } from "rxjs";
import swal from "sweetalert2";

import { DinamicData, Cell } from "../../../models/dinamic-data";

/*COMPONENTES*/
import { CardComponent } from "../card/card.component";

/*SERVICIOS*/
import { InventoryService } from "../../../services/inventory.service";
import { SecurazeService } from "../../../services/securaze.service";
import { UserService } from "../../../services/user.service";
import { TestingRecordService } from "../../../services/testing-records.service";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { LocationService } from "../../../services/location.service";
import { TicketsService } from "../../../services/tickets.service";

/*IMPORTACIONES DE ANGULAR MATERIAL TREE*/
import { SelectionModel } from "@angular/cdk/collections";
//import {FlatTreeControl} from '@angular/cdk/tree';

import { FlatTreeControl } from "@angular/cdk/tree";

import { Injectable } from "@angular/core";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { BehaviorSubject } from "rxjs";
import { ConfigService } from "../../../services/config.service";

/*ANGULAR MATERIAL TREE*/

export class TodoItemNode {
  children: TodoItemNode[];
  label: string;
  id: number;
  is_checked: boolean;
  is_father: number;
  new: boolean = false;
}

export class TodoItemFlatNode {
  label: string;
  level: number;
  expandable: boolean;
  id: number;
  is_checked: boolean;
  is_father: number;
  new: boolean = false;
}

let TREE_DATA = [];

@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  public token;

  constructor(
    private _securazeService: SecurazeService,
    private _userService: UserService,
  ) {
    this.token = this._userService.getToken();
    this.initialize();
  }

  initialize() {
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    const data = this.buildFileTree(TREE_DATA, 0);

    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */
  buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const item = obj[key];
      const node = new TodoItemNode();
      node.label = obj[key].name;
      node.id = obj[key].id;
      node.is_checked = obj[key].is_checked;
      /*node.claimId=  obj[key].claimId;
      node.isPlanType=  obj[key].isPlanType;*/
      node.is_father = obj[key].is_father;

      if (item != null) {
        if (typeof item === "object" && item.children != undefined) {
          node.children = this.buildFileTree(item.children, level + 1);
        } else {
          node.label = item.name;
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    let id = new Date().getTime();

    //Se arma el child que se agregará (es como guardarlo en memoria del árbol)
    const child = <TodoItemNode>{
      label: name,
      id: id,
      is_checked: false,
      is_father: parent.id,
      new: true,
    };

    //Si el padre ya tiene hijos o si no
    if (parent.children) {
      // parent already has children
      parent.children.push(child);
      this.dataChange.next(this.data);
    } else {
      // if parent is a leaf node

      //Se vacía el array, se añade y el .next se usa para ver los cambios inmediatamente
      parent.children = [];
      parent.children.push(child);
      this.dataChange.next(this.data);
    }
  }

  deleteItem(parent: TodoItemNode, name: string) {
    //Se saca el nodo "temporal" que se había "agregado" ya que solo fue internamente
    parent.children.pop();

    //Si el nodo "padre" no tiene hijos se vuelve a convertir en el último hijo
    if (parent.children.length === 0) delete parent.children;

    //Se ven los cambios a nivel interno en el árbol
    this.dataChange.next(this.data);
  }

  updateItem(node: TodoItemNode, name: string) {
    node.label = name;

    let json = {
      name: name,
      father: node.is_father,
      id_temporal: node.id,
    };

    this._securazeService.newCategory(this.token, json).subscribe(
      (response) => {
        if (response.status == "success") {
          node.id = response.data.id;
          this.dataChange.next(this.data);
        } else {
          this.showSwal("error", "ERROR!", response.msg);
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
}

@Component({
  selector: "app-attribute-multiple-items",
  templateUrl: "./attribute-multiple-items.component.html",
  styleUrls: ["./attribute-multiple-items.component.css"],
  providers: [
    UserService,
    SecurazeService,
    ChecklistDatabase,
    InventoryService,
    TestingRecordService,
    PrincipalinventoryService,
    LocationService,
    TicketsService,
  ],
})
export class attributeMultipleItemsComponent implements OnInit {
  public mtds: Methods = new Methods();

  public loading: boolean = false;

  //Identidad del usuario
  public identity;
  public token;

  //Diferentes tipos de búsqueda
  public choosesearch = "inventory";
  public searchValue = "";
  public searching = false;
  public saving = false;

  public searchvalues = [
    { value: "inventory", viewValue: "Inventory ID" },
    { value: "id", viewValue: "Dashboard ID" },
    { value: "po", viewValue: "PO# & Line Item" },
    { value: "sn", viewValue: "Serial Number" },
  ];

  /*DIRTY GUARD*/
  public isDirty = false;

  public multipleData: DinamicData = new DinamicData([
    "Id",
    "PO-LINE",
    "IQ ID",
    "Mfgr",
    "Item",
    "Serial#",
    "Type",
    "Condition",
    "Customer Asset",
  ]);

  /*IDS RECIBIDOS PARA INTEGRAR A LA TABLA*/
  public idsMultiple;

  /*ITEMS EN LA TABLA*/
  public bulk: Array<number> = [];

  /*Mensajes de error*/
  public notFound = false;
  public mensajeError = "";

  //Saber el Id del Inventory que me regresa la función de PO
  public id_inventory = "";

  /*GUARDAR VIRTUAL CONTAINER*/
  public virtualContainerName = "";
  public savingcontainer = false;

  public idsCategories: Array<any> = [];
  public masterLabel: string;

  public nodeCollapse: Array<any> = [];
  public config: Array<any> = [];

  /*ANGULAR MATERIAL TREE*/

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = "";

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(
    true /* multiple */,
  );

  constructor(
    public dialogRef: MatDialogRef<attributeMultipleItemsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router: Router,
    private _userService: UserService,
    private _securazeService: SecurazeService,
    private _inventoryService: InventoryService,
    private _testingService: TestingRecordService,
    private _service: PrincipalinventoryService,
    private _locationService: LocationService,
    private _ticketsService: TicketsService,
    public dialog: MatDialog,
    private database: ChecklistDatabase,
    private _config: ConfigService,
  ) {
    this.idsMultiple = data;

    //console.log(typeof(this.idsMultiple));

    //this.idsMultiple = '1-2-3';

    //console.log(typeof(this.idsMultiple));

    //Verificamos identidad
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.apiCompany = this.identity.apiCompany;

    this.getNodeCollapse();

    //Obtenemos las categorías y los containers
    this.getCategoriesNew();

    /*ANGULAR MATERIAL TREE*/
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren,
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(
      this.getLevel,
      this.isExpandable,
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener,
    );

    database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
      this.refreshTree();
      //console.log(this.dataSource.data);
    });
  }

  ngOnInit() {
    this.getContainers();
    this.getVirtualContainers();
    this._config.getConfig("attributeMultipleList").subscribe(
      (r) => {
        if (r.data) {
          this.config = JSON.parse(r.data.data);
        } else {
          this.config = this.mtds.colopt(this.multipleData.headers, [false]);
        }
        this.getListItems();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      },
    );
  }
  updateConfig(e) {
    this.config = e;
    console.log(this.config);
    this._config
      .setConfig("attributeMultipleList", this.config)
      .subscribe((r) => {
        console.log(r);
      });
  }
  removeAttributesModal() {
    $("#modalDelete").modal("show");
  }

  removeAttributes() {
    let json = {
      bulk: this.bulk,
    };

    this._service.removeAttributes(json).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showSwal(
            "success",
            "Changes Saved!",
            "The Attributes have been removed",
          );
          $("#modalDelete").modal("hide");
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  save() {
    this.saving = true;

    this.categories_selected = [];

    //SE ENCARGA DE JALAR TAMBIÉN LOS CHECKS "PARCIALES"
    const partial = this.treeControl.dataNodes.filter((x) =>
      this.descendantsPartiallySelected(x),
    );

    this.categories_selected = partial.concat(this.checklistSelection.selected);

    let json = {
      categoriesSelected: this.categories_selected,
      bulk: this.bulk,
    };

    this._inventoryService.saveMultipleItems(this.token, json).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showSwal(
            "success",
            "Changes Saved!",
            "The changes have been saved",
          );
          this.saving = false;
          this.isDirty = false;
        } else if (response.status === "error") {
          this.showSwal("error");
          this.saving = false;
          this.isDirty = false;
        }
      },
      (error) => {
        console.log(<any>error);
        this.showSwal("error");
        this.saving = false;
        this.isDirty = false;
      },
    );
  }
  filtros = [];

  limpiarItem() {
    //Borramos Mensajes de Error4
    this.mensajeError = "";
    this.notFound = false;
  }

  searchInventory() {
    this.limpiarItem();

    this.searching = true;
    this.loading = true;

    let json = {
      type: this.choosesearch,
    };

    this._securazeService
      .getInventoryInfo(this.token, this.searchValue, json)
      .subscribe(
        (response) => {
          if (response.status == "success") {
            console.log(response);
            this.filtros = [
              {
                key: "id",
                title: "ID",
                value: "",
                type: "contains",
                key_type: "id_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "po_line",
                title: "PO Line",
                value: "",
                type: "contains",
                key_type: "po_line_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "iq_id",
                title: "IQ ID",
                value: "",
                type: "contains",
                key_type: "iq_id_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "mfgr",
                title: "Mfgr",
                value: "",
                type: "contains",
                key_type: "mfgr_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "item_type",
                title: "Item",
                value: "",
                type: "contains",
                key_type: "item_type_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "serial_number",
                title: "Serial #",
                value: "",
                type: "equalto",
                key_type: "serial_number_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "contains", name: "Contains" },
                  { value: "startswith", name: "Starts With" },
                  { value: "endswith", name: "Ends With" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "type",
                title: "Type",
                value: "",
                type: "equalto",
                key_type: "type_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notequalto", name: "Not Equal To" },
                  { value: "greaterthan", name: "Greater Than" },
                  { value: "lessthan", name: "Less Than" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "condition",
                title: "Condition",
                value: "",
                type: "equalto",
                key_type: "condition_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notequalto", name: "Not Equal To" },
                  { value: "greaterthan", name: "Greater Than" },
                  { value: "lessthan", name: "Less Than" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
              {
                key: "custommer_asset",
                title: "Customer Asset",
                value: "",
                type: "equalto",
                key_type: "custommer_asset_type",
                type_options: [
                  { value: "nofilter", name: "No Filter" },
                  { value: "equalto", name: "Equal To" },
                  { value: "notequalto", name: "Not Equal To" },
                  { value: "greaterthan", name: "Greater Than" },
                  { value: "lessthan", name: "Less Than" },
                  { value: "notcontain", name: "Does Not Contain" },
                ],
              },
            ];
            if (!this.bulk.includes(response.inventory.id)) {
              this.multipleData.rows.push([
                //new Cell(response.inventory.id, {type: 'checkbox'}),
                new Cell(response.inventory.id),
                new Cell(
                  response.inventory.po !== null
                    ? `${response.inventory.po.po}-${response.inventory.poline}`
                    : "",
                ),
                new Cell(response.inventory.inventoryid),
                new Cell(response.inventory.mfgr),
                new Cell(response.inventory.item),
                new Cell(response.inventory.serialnumber),
                new Cell(
                  response.inventory.master &&
                    response.inventory.master.inventoryCategory
                    ? response.inventory.master.inventoryCategory.name
                    : "",
                ),
                new Cell(response.inventory.conditioninventory),
                new Cell(response.inventory.customerAsset),
              ]);

              this.bulk.push(parseInt(response.inventory.id));
              //this.isDirty = true;
            } else {
              this.notFound = true;
              this.showToast("error", "Nothing Found", 2000);

              this.mensajeError = "The item already exists";
            }
          } else {
            if (response.msg == "Authorization not valid") {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            } else {
              this.notFound = true;
              this.showToast("error", "Nothing Found", 2000);

              this.mensajeError = "Nothing found";
            }
          }
          this.searching = false;
          this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.showSwal("error");
          this.searching = false;
          this.loading = false;
        },
      );
  }

  public async getDataPO() {
    this.limpiarItem();

    this.searching = true;
    this.loading = true;

    let json: any;
    json = {
      type: "LISTPOPLINE",
      busqueda: this.searchValue,
    };

    let searchValuePo = this.searchValue;

    let response = await this._testingService
      .showAll(json)
      .toPromise()
      .then(
        async (response) => {
          if (response.status !== "error") {
            if (response.data.length == 0) {
              this.notFound = true;
              this.mensajeError = "Nothing found";
              this.showToast("error", "Nothing Found", 2000);

              this.searching = false;
              this.loading = false;
              return false;
            }

            if (typeof response.data[0] === "undefined") {
              this.data = response.data;
              console.log("entramos 666");
            } else {
              if (typeof response.data[0] === "object") {
                this.data = response.data[0];
                console.log("entramos 0");
                if (typeof this.data[0] === "object") {
                  this.data = this.data[0];
                  console.log("entramos 0");
                }
              } else if (typeof response.data[0] !== undefined) {
                this.data = response.data[0][0];
                console.log("entramos 1");
              } else {
                this.data = response.data;
                console.log("entramos 2");
              }
            }

            this.id_inventory = this.data.id;
            /*this.podate = this.getFecha(this.data.po.date);*/

            this.searchValue = this.id_inventory;
            this.choosesearch = "id";

            await this.searchInventory();

            this.searchValue = searchValuePo;
            this.choosesearch = "po";
          } else if (response.status === "error") {
            this.notFound = true;
            this.showToast("error", "Nothing Found", 2000);

            this.mensajeError = response.msg;
            this.loading = false;
            this.searching = false;
          }
        },
        (error) => {
          console.log(<any>error);
          this.showSwal("error");
          this.loading = false;
          this.searching = false;
        },
      );
  }

  getListItems() {
    this.loading = true;

    /*if(this.idsMultiple.includes('-')){
      
      this.idsbulk = this.idsMultiple.split('-');

      for (let element of this.idsbulk) {
        this.bulk.push(parseInt(element));  
      }
      
    }else{
      this.bulk.push(this.idsMultiple);
    }*/

    if (typeof this.idsMultiple === "number") {
      this.bulk.push(this.idsMultiple);
    } else {
      for (let element of this.idsMultiple) {
        this.bulk.push(parseInt(element));
      }
    }

    let ids = String(this.bulk).replace(/,/g, "-");

    let json = {
      ids: ids,
    };

    this._inventoryService
      .getMultipleItems(this.token, json)
      .subscribe((response) => {
        if (response.status === "success") {
          this.filtros = [
            {
              key: "id",
              title: "ID",
              value: "",
              type: "contains",
              key_type: "id_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "po_line",
              title: "PO Line",
              value: "",
              type: "contains",
              key_type: "po_line_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "iq_id",
              title: "IQ ID",
              value: "",
              type: "contains",
              key_type: "iq_id_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "mfgr",
              title: "Mfgr",
              value: "",
              type: "contains",
              key_type: "mfgr_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "item_type",
              title: "Item",
              value: "",
              type: "contains",
              key_type: "item_type_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "serial_number",
              title: "Serial #",
              value: "",
              type: "equalto",
              key_type: "serial_number_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "contains", name: "Contains" },
                { value: "startswith", name: "Starts With" },
                { value: "endswith", name: "Ends With" },
                { value: "equalto", name: "Equal To" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "type",
              title: "Type",
              value: "",
              type: "equalto",
              key_type: "type_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "equalto", name: "Equal To" },
                { value: "notequalto", name: "Not Equal To" },
                { value: "greaterthan", name: "Greater Than" },
                { value: "lessthan", name: "Less Than" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "condition",
              title: "Condition",
              value: "",
              type: "equalto",
              key_type: "condition_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "equalto", name: "Equal To" },
                { value: "notequalto", name: "Not Equal To" },
                { value: "greaterthan", name: "Greater Than" },
                { value: "lessthan", name: "Less Than" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
            {
              key: "custommer_asset",
              title: "Customer Asset",
              value: "",
              type: "equalto",
              key_type: "custommer_asset_type",
              type_options: [
                { value: "nofilter", name: "No Filter" },
                { value: "equalto", name: "Equal To" },
                { value: "notequalto", name: "Not Equal To" },
                { value: "greaterthan", name: "Greater Than" },
                { value: "lessthan", name: "Less Than" },
                { value: "notcontain", name: "Does Not Contain" },
              ],
            },
          ];
          this.multipleData.rows = [];

          for (let element of response.data) {
            this.multipleData.rows.push([
              //new Cell(element.id, {type: 'checkbox'}),
              new Cell(element.id),
              new Cell(
                element.po !== null ? `${element.po.po}-${element.poline}` : "",
              ),
              new Cell(element.inventoryid),
              new Cell(element.mfgr),
              new Cell(element.item),
              new Cell(element.serialnumber),
              new Cell(
                element.master && element.master.inventoryCategory
                  ? element.master.inventoryCategory.name
                  : "",
              ),
              new Cell(element.conditioninventory),
              new Cell(element.customerAsset),
            ]);
          }
        }
        this.loading = false;
      });
  }

  changesDirty() {
    let response = confirm(
      "We have detected that there are some unsaved changes to this item. Are you sure you want to leave?",
    );

    return response;
  }

  chooseSearch(value) {
    //se limpian valores de búsqueda
    this.searchValue = "";
    this.mensajeError = "";
    this.notFound = false;
  }

  close() {
    if (this.isDirty) {
      let r = this.changesDirty();

      if (r) this.dialogRef.close();
    } else this.dialogRef.close();
  }

  /*NUEVA SECCIÓN DE CATEGORÍAS*/

  public addmaster: boolean = false;
  public masterCategory = "";
  public categories_final = [];
  public categories_selected = [];
  public itemID = 0;
  public itemMasterID = 0;
  public showTree: boolean = false;

  public apiCompany;

  // Array que contiene el nodo a mostrar en el input
  public ids_add = [];

  // Nodo que se eliminará al crear un nuevo array
  public nodoEliminar;

  // Valor que tiene el input del nodo a agregar
  public itemValue;

  // Mostrar u ocultar sección para asignar un container
  public showContainer = false;
  public loadingContainers = false;
  public containers = [];

  // Mostrar u ocultar sección para asignar un virtual container
  public showVirtualContainer = false;
  public virtualContainers = [];

  AddMasterShow() {
    this.addmaster = true;
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
  getCategoriesNew() {
    let hidden = 0;

    this._securazeService
      .getCategoriesTreeBot(this.itemID, this.apiCompany, hidden)
      .subscribe(
        (response) => {
          //Desmarcar los checkbox cada que se cargan las categorías
          for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (
              this.checklistSelection.isSelected(this.treeControl.dataNodes[i])
            )
              this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
          }

          //console.log(response);
          TREE_DATA = response;

          if (TREE_DATA.length > 0) this.showTree = true;

          this.database.initialize();
          this.checkAll();
        },
        (error) => {
          console.log(error);
        },
      );
  }

  getCategoriesMaster() {
    let hidden = 0;

    this._securazeService
      .getCategoriesMasterTreeBot(this.itemMasterID, this.apiCompany, hidden)
      .subscribe(
        (response) => {
          //Desmarcar los checkbox cada que se cargan las categorías
          for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (
              this.checklistSelection.isSelected(this.treeControl.dataNodes[i])
            )
              this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
          }

          //console.log(response);
          TREE_DATA = response;

          if (TREE_DATA.length > 0) this.showTree = true;

          this.database.initialize();
          this.checkAll();
        },
        (error) => {
          console.log(error);
        },
      );
  }

  checkAll() {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if (this.treeControl.dataNodes[i].is_checked) {
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
      }

      //this.treeControl.expand(this.treeControl.dataNodes[i]);
    }
  }

  /*You can get the value directly from the checklistselection

  values = this.checklistSelection.selected

  This will return you exactly the value of all checked items*/

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) =>
    _nodeData.label === "";

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.label === node.label
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.label = node.label;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.is_checked = node.is_checked;
    /*flatNode.claimId = node.claimId;
    flatNode.isPlanType = node.isPlanType;*/
    flatNode.is_father = node.is_father;
    flatNode.expandable = !!node.children;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child),
    );
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child),
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    //Se agrega el dirty al formulario
    this.isDirty = true;

    //Toggle actúa como interruptor para poner on/off al padre
    this.checklistSelection.toggle(node);

    //Se obtienen los descendientes del nodo
    const descendants = this.treeControl.getDescendants(node);

    //Si el nodo padre está seleccionado se seleccionan los descendientes y viceversa
    /*this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);*/

    if (this.checklistSelection.isSelected(node)) {
      //Se seleccionan los descendientes
      //this.checklistSelection.select(...descendants);

      //Se usa para expandir todo el árbol del nodo padre
      this.treeControl.expand(node);

      //Se recorren los descendientes para expandirlos
      for (let i = 0; i < descendants.length; i++) {
        this.treeControl.expand(descendants[i]);
      }
    } else {
      //Se deseleccionan los descendientes
      this.checklistSelection.deselect(...descendants);

      //Se recorren los descendientes para contraerlos
      for (let i = 0; i < descendants.length; i++) {
        this.treeControl.collapse(descendants[i]);
      }

      //Se usa para contraer todo el árbol del nodo padre
      this.treeControl.collapse(node);
    }

    // Force update for the parent
    descendants.every((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    /* FUNCIÓN PARA AL SELECCIONAR SE CONTRAIGA LA CATEGORÍA ACTUAL Y SE EXPANDA LA SIGUIENTE*/

    //Se obtiene el padre del nodo actual
    let parent = this.getParentNode(node);

    //Se obtiene el nivel del padre del nodo actual
    let parentLevel = parent.level;

    //Se obtiene el id del padre del nodo actual
    let parentId = parent.id;

    /*Esto se usa para guardar en la base de datos solo los ids de los últimos hijos
      esto para después pintar en una tabla los valores, no tiene nada qué ver con el
      collapse*/
    if (!node.is_checked) {
      this.idsCategories.push(Number(node.id));
      this.getParentRecursive(node);
    } else
      this.idsCategories = this.idsCategories.filter(
        (id) => id != Number(node.id),
      );

    //Se busca dentro del array que regresó el backend para ver si su id se colapsa o no
    if (!this.nodeCollapse.includes(Number(parentId))) {
      //Se usa para contraer todo el árbol del nodo padre
      this.treeControl.collapse(parent);

      //Ahora se obtiene el nodo padre del padre para poder expander el siguiente nodo
      let grandParent = this.getParentNode(parent);

      //Se obtienen los descendientes del padre del padre, solo que vienen con todos los nodos de todos sus hijos
      const partialDescendants = this.treeControl.getDescendants(grandParent);

      //Se filtran para obtener solo los descendientes del nivel que queremos.
      const descendants = partialDescendants.filter(
        (node) => node.level === parentLevel,
      );

      //Se obtiene la posición en el array del nodo que ya se selecciono para hacer el barrido de los nodos restantes si es que tienen hijos
      const index = descendants.findIndex((node) => node.id === parentId);

      //Si encontramos la posición del nodo padre
      if (index !== -1) {
        //Recorremos los nodos a partir de la posición siguiente y si tiene hijos lo expandimos
        for (let i = index + 1; i < descendants.length; i++) {
          //Se obtienen los descendientes del nodo
          const children = this.treeControl.getDescendants(descendants[i]);

          //Si sí tiene hijos se expande y se rompe el ciclo
          if (children.length > 0) {
            this.treeControl.expand(descendants[i]);
            break;
          }
        }
      }
    }

    /* FUNCIÓN PARA AL SELECCIONAR SE CONTRAIGA LA CATEGORÍA ACTUAL Y SE EXPANDA LA SIGUIENTE*/

    //Se agrega el dirty al formulario
    this.isDirty = true;

    this.checklistSelection.toggle(node);
    node.is_checked ? (node.is_checked = false) : (node.is_checked = true);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child),
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  deleteInputItem(node: TodoItemFlatNode) {
    //Se vacía el array
    this.ids_add = [];

    //Se manda el nodo a eliminar
    this.database.deleteItem(this.nodoEliminar!, "");
  }

  /** Select the category so we can insert the new item. */
  addNewItem(node: TodoItemFlatNode) {
    const parentNode = this.flatNodeMap.get(node);

    //Obtenemos el id del nodo padre (que agregará un nodo hijo)
    let id_node = parentNode.id;

    //Si ya incluye el array de ids de nodos el nodo no entra a la condición
    //Esto evita que se dupliquen los inputs
    if (!this.ids_add.includes(id_node)) {
      //Si el array ya contiene un id, se elimina el que está ya que esto significa
      //Que están intentando añadir un nodo hijo en un nodo diferente
      if (this.ids_add.length > 0) {
        //Como ya existía un nodo previo la variable nodoEliminar ya contenía el nodo
        //Es el que se mana al método para que lo dé de baja
        this.database.deleteItem(this.nodoEliminar!, "");
      }

      //Se vacía el array para poder agregar el nuevo nodo que tendrá el input
      this.ids_add = [];

      //Agregamos al arreglo de ids (que solo debe contener el nodo que agregará el nuevo hijo)
      this.ids_add.push(id_node);

      //Será el próximo nodo que se "eliminará" si se abre otro input
      this.nodoEliminar = parentNode;

      /*** this block will be used to determine wither we should expand the subtree or not.      **/
      let isParentHasChildren: boolean = false;
      if (parentNode.children) isParentHasChildren = true;
      /** end of the block **/

      /*** Con esta línea agregamos el parentNode para mostrar el input ***/
      this.database.insertItem(parentNode!, "");

      // expand the subtree only if the parent has children (parent is not a leaf node)
      if (isParentHasChildren) this.treeControl.expand(node);
      else this.treeControl.expand(node);
    }
  }

  /** Save the node to database */
  //saveNode(node: TodoItemFlatNode, itemValue: string) {
  saveNode(node: TodoItemFlatNode) {
    const nestedNode = this.flatNodeMap.get(node);

    //this.itemValue = this.workflowForm.get("formitemValue").value;

    this.database.updateItem(nestedNode!, this.itemValue);

    this.itemValue = "";
    this.isDirty = false;

    this.ids_add = [];

    //this.workflowForm.get("formitemValue").setValue('', { emitEvent: false });
  }

  refreshTree() {
    let _data = this.dataSource.data;
    this.dataSource.data = [];
    this.dataSource.data = _data;
  }

  SaveCategoriesSelected(param) {
    //EN ESTE ARREGLO METÍA LAS CATEGORÍAS AGREGADAS PERO YA NO SIRVE
    this.categories_final = [];
    this.categories_selected = [];

    //SE ENCARGA DE JALAR TAMBIÉN LOS CHECKS "PARCIALES"
    const partial = this.treeControl.dataNodes.filter((x) =>
      this.descendantsPartiallySelected(x),
    );

    this.categories_selected = partial.concat(this.checklistSelection.selected);

    let json = {
      categoriesSelected: this.categories_selected,
      categoriesAdded: this.categories_final,
      itemID: this.itemID,
      childCategories: this.idsCategories,
      masterCategoryLabel: this.masterLabel,
    };

    this._securazeService.saveCategories(this.token, json).subscribe(
      (response) => {
        //this.getCategories();
        /*if(response.status === 'success'){
          
          if(param === 1)
            this.showSwal('success', 'Checks Saved!', 'The checks have been saved');
        }*/
      },
      (error) => {
        console.log(error);
      },
    );
  }

  AddCategoryNew() {
    //this.SaveCategoriesSelected(0);

    let id_temporal = new Date().getTime();

    //this.masterCategory = this.workflowForm.get("formmasterCategory").value;

    let json = {
      name: this.masterCategory,
      father: 0,
      id_temporal: id_temporal,
    };

    this._securazeService.newCategory(this.token, json).subscribe(
      (response) => {
        if (response.status == "success") {
          this.getCategoriesNew();
          this.masterCategory = "";
          //this.workflowForm.get("formmasterCategory").setValue('', { emitEvent: false });
          this.isDirty = false;
          this.addmaster = false;
        } else {
          this.showSwal("error", "ERROR!", response.msg);
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getNodeCollapse() {
    this._securazeService.getNodeCollapse(this.token).subscribe(
      (response) => {
        if (response.status == "success") {
          this.nodeCollapse = response.data;
        } else {
          //this.mtds.notifyError(response.msg);
          console.log(response.msg);
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getParentRecursive(node) {
    let parent = this.getParentNode(node);

    console.log(parent);

    if (parent.level !== 0) this.getParentRecursive(parent);
    else {
      this.masterLabel = parent.label;
    }
  }

  procesar(action, mark) {
    let ids = String(this.bulk).replace(/,/g, "-");
    let changeMark;

    if (mark === 1) changeMark = "TESTED";
    else changeMark = "NOT TESTED";

    if (action === "test") {
      this._service.testBulkItem(ids, changeMark).subscribe(
        (response) => {
          if (response.status === "success") {
            this.showSwal(
              "success",
              "Changes Saved!",
              "The changes have been saved",
            );
          }
        },
        (error) => {
          console.log(error);
        },
      );
    }

    if (action === "container") {
      this.showContainer = true;
    }

    if (action === "virtualcontainer") {
      this.showVirtualContainer = true;
    }
  }

  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();

    //console.log(event);

    // Perform any other scrolling logic you need here
    // For example, you can manually adjust the child's scrollTop property.
    //this.childScrollElement.nativeElement.scrollTop += event.deltaY;
  }

  getContainers() {
    this.loadingContainers = true;
    this._locationService.getContainersInput(this.token).subscribe(
      (r) => {
        console.log(r);
        this.loadingContainers = false;
        this.containers = r.data.map((element) => {
          return {
            id: element.id,
            name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation : ""
            }`,
            /*name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation.locationName  + ': ' + element.internalLocation.locationRow + ' - ' +
              element.internalLocation.locationBay + ' - ' + element.internalLocation.locationLevel + ' - ' + element.internalLocation.locationSection : ''
            }`*/
          };
        });
      },
      (error) => {
        this.loadingContainers = false;
      },
    );
  }

  getVirtualContainers() {
    this.loadingContainers = true;
    this.virtualContainers = [];

    this._securazeService.getContainers(this.token).subscribe(
      (response) => {
        response.data.forEach(
          function (element) {
            this.virtualContainers.push({
              id: element.id,
              name: element.nameVirtualContainer,
            });
          }.bind(this),
        );

        this.virtualContainers.sort((a, b) => {
          const n1 = a.name.toLowerCase();
          const n2 = b.name.toLowerCase();

          if (n1 < n2) {
            return -1;
          }
          if (n1 > n2) {
            return 1;
          }
          return 0;
        });

        /*if(param === 1)
          this.showC = true;*/
        this.loadingContainers = false;
      },
      (error) => {
        this.loadingContainers = false;
      },
    );
  }

  saveContainer(e) {
    let ids = String(this.bulk).replace(/,/g, "-");

    this._service.bulkContainer(ids, e.id).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showSwal(
            "success",
            "Changes Saved!",
            "The changes have been saved",
          );
          this.showContainer = false;
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  saveVirtualContainer(e) {
    let ids = String(this.bulk).replace(/,/g, "-");

    this._service.bulkVirtualContainer(ids, e.id).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showSwal(
            "success",
            "Changes Saved!",
            "The changes have been saved",
          );
          this.showVirtualContainer = false;
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  cancelContainer() {
    this.showContainer = false;
    this.showVirtualContainer = false;
  }

  addVirtualContainer() {
    this.savingcontainer = true;
    this.loadingContainers = false;

    let json = {
      enableAsAVirtualContainer: 1,
      nameVirtualContainer: this.virtualContainerName,
    };

    this._ticketsService
      .createVirtual(json)
      .toPromise()
      .then(
        async (response) => {
          if (response.code === 200) {
            this.showSwal(
              "success",
              "Container Saved!",
              "Container has been saved successfully",
            );
            //this.mtds.notifySuccess('Container has been saved successfully');

            await this.getVirtualContainers();
          } else if (response.code === 400) {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else {
            //this.mtds.notifyError(response.msg, response.code);
            this.showSwal("error", "ERROR!", response.msg);
          }

          this.savingcontainer = false;
          this.virtualContainerName = "";
        },
        (error) => {
          this.savingcontainer = false;
          //this.mtds.notifyError(error.statusText, error.status);
          this.showSwal("error", "ERROR!", error.status);
        },
      );
  }

  handleEnter() {
    if (this.choosesearch === "po") {
      this.getDataPO();
    } else {
      this.searchInventory();
    }
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
}
